
import Vue from 'vue'

import 'src/assets/iconfont'
import iconFont from 'src/components/iconFont'
import Single from 'src/components/imageUpload/single.vue'
import Multiple from 'src/components/imageUpload/multiple.vue'
import File from 'src/components/imageUpload/file.vue'
import TimeClock from '@/components/charts/timeClock.vue'
import ChartFontFamilySelect from '@/components/common/ChartFontFamilySelect.vue'

// IconFont
Vue.component('Icon', iconFont)
// 大屏画布动态 :is="chartComponentType"，全局注册避免插槽/作用域下解析不到
Vue.component('TimeClock', TimeClock)
// 大屏统一字体下拉（数据见 @/utils/chartTitlePresets.js）
Vue.component('ChartFontFamilySelect', ChartFontFamilySelect)
// 单图片上传
Vue.component('Single', Single)
// 多图上传
Vue.component('Multiple', Multiple)
// 文件上传
Vue.component('File', File)
